/* Orders – dashboard widget
   ✱ Spec   : 01 Jul 2025
   ✱ Styles : OrderCountWidget.scss
*/
import React from 'react';
import {Link} from 'react-router-dom';
import './OrderCountWidget.scss';

export interface OrderCountCardProps {
  totalOrders?: number;
  numPaid?: number;
  numUnpaid?: number;
  numInProgress?: number;
  startDate?: Date | string;
  endDate?: Date | string;
}

export default function OrderCountCard({
  totalOrders = 0,
  numPaid = 0,
  numUnpaid = 0,
  numInProgress = 0,
  startDate,
  endDate,
}: OrderCountCardProps) {
  const fmt = (n: number) => n.toLocaleString();

  // Build query string with date parameters if provided
  const buildQueryString = (baseParams: string) => {
    const params = new URLSearchParams(baseParams);
    if (startDate) {
      const start =
        startDate instanceof Date
          ? startDate.toISOString().split('T')[0]
          : new Date(startDate).toISOString().split('T')[0];
      params.set('startDate', start);
    }
    if (endDate) {
      const end =
        endDate instanceof Date
          ? endDate.toISOString().split('T')[0]
          : new Date(endDate).toISOString().split('T')[0];
      params.set('endDate', end);
    }
    return `/orders?${params.toString()}`;
  };

  return (
    <div className="order-count-card">
      {/* left half */}
      <div className="order-left">
        <span className="widget-heading">Inputs Orders</span>

        <span className="orders-value">{fmt(totalOrders)}</span>

        <span className="orders-subheading">Total orders</span>
      </div>

      {/* right half */}
      <ul className="legend">
        <LegendItem
          colour="paid"
          label={`Paid (${fmt(numPaid)})`}
          link={buildQueryString('paid=1')}
        />
        <LegendItem
          colour="unpaid"
          label={`Unpaid (${fmt(numUnpaid)})`}
          link={buildQueryString('paid=0')}
        />
        <LegendItem
          colour="progress"
          label={`In progress (${fmt(numInProgress)})`}
          link={buildQueryString('status=IN_PROGRESS')}
        />
      </ul>
    </div>
  );
}

function LegendItem({
  colour,
  label,
  link,
}: {
  colour: 'paid' | 'unpaid' | 'progress';
  label: string;
  link: string;
}) {
  return (
    <li className={colour}>
      <Link to={link}>
        <span className="square" />
        {label}
      </Link>
    </li>
  );
}
